import { render, staticRenderFns } from "./interests.vue?vue&type=template&id=5162483a&scoped=true&"
import script from "./interests.vue?vue&type=script&lang=js&"
export * from "./interests.vue?vue&type=script&lang=js&"
import style0 from "./interests.vue?vue&type=style&index=0&id=5162483a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5162483a",
  null
  
)

export default component.exports